import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { Button } from './Button';
import { FAIcon } from './fa-icon';
import { i18n } from '../i18n/translate';
import { pickDataAttributes } from '../utils';

export class ModalHeader extends Component {
  static propTypes = {
    canClickOff: PropTypes.bool,
    className: PropTypes.string,
    closeButton: PropTypes.bool,
    closeButtonIcon: PropTypes.string,
    description: PropTypes.string,
    descriptionComponentClass: PropTypes.string,
    descriptionComponentType: PropTypes.elementType,
    onCancel: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    titleComponentType: PropTypes.elementType,
    titleId: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    closeButton: true,
    closeButtonIcon: 'xmark',
    description: '',
    descriptionComponentClass: 'p2',
    descriptionComponentType: 'p',
    titleComponentType: 'h2',
  };

  render() {
    const {
      className,
      canClickOff,
      onCancel,
      title,
      titleId,
      closeButton,
      closeButtonIcon,
      description,
      titleComponentType,
      descriptionComponentClass,
      descriptionComponentType: DescriptionComponent,
    } = this.props;
    const dataAttributes = pickDataAttributes(this.props);

    return (
      <Modal.Header className={className} closeButton={false} onHide={onCancel}>
        {canClickOff && closeButton && (
          <Button
            {...dataAttributes}
            aria-label={i18n.t('Close')}
            className="pull-right close-link"
            data-action="close-modal"
            onClick={onCancel}
            style="default"
          >
            <FAIcon icon={closeButtonIcon} />
          </Button>
        )}
        {title && (
          <Modal.Title id={titleId} as={titleComponentType} data-action="modal-title">
            {title}
          </Modal.Title>
        )}
        {description && (
          <DescriptionComponent className={`${descriptionComponentClass} modal-description`}>
            {description}
          </DescriptionComponent>
        )}
      </Modal.Header>
    );
  }
}
